import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CorrAxesTable from '../../corrCluster/Correspondence/CorrAxesTable';

const GenericSHTableCellContent = ({
  rowData,
  index,
  isCorrAxesTable,
 }) => {
  return (
    <Fragment>
      {isCorrAxesTable &&
        <CorrAxesTable
          data-test="genericSHTCellContentCompponent"
          rowData={rowData}
          index={index}
        />}
    </Fragment>
  );
};

GenericSHTableCellContent.propTypes = {
  rowData: PropTypes.shape({}),
  isCorrAxesTable: PropTypes.bool,
  index: PropTypes.number,
};

export default GenericSHTableCellContent;
